import { PUT_STAFF_CARDS_ERROR, PUT_STAFF_CARDS_START, PUT_STAFF_CARDS_SUCCESS } from '../../types';

export default function put_staff_cards(state, action) {
  switch (action.type) {
    case PUT_STAFF_CARDS_START:
      return { ...state };
    case PUT_STAFF_CARDS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_STAFF_CARDS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}